import React, { useEffect, useState, useMemo } from 'react';
import Header from '../../components/header';
import Layout from '../../components/layout';
import { AgGridReact } from 'ag-grid-react';
import { AllCommunityModule, ModuleRegistry } from "ag-grid-community";
import toast from 'react-hot-toast';
import moment from 'moment';
import { DATE_FORMAT, PAGE_SIZE } from '../../_common/constant';
import Pagination from '../../components/pagination';
import Search from '../../components/search';
import Loader from '../../components/loader';
import { useDepreciationApi } from '../../store/api/hooks/depreciationApiHook';
import Button from '../../components/elements/button';
import { useSagesApi } from '../../store/api/hooks/sageApiHook';
import { useFacilitiesApi } from '../../store/api/hooks/facilitiesApiHook';
import { URLS } from '../../_config';
import Currency from '../../components/currency';
import { useLocation } from 'react-router-dom';
import { useUserSelector } from '../../store/selectors/userSelector';
import { downloadExcel, getPermissionInfo } from '../../_common/functions';
import { Dropdown, Menu } from '../../components/Dropdown';
import { filterConfigType } from '../../_config/types';
import Filters from '../../components/filters';
import Icon from '../../components/icons';

ModuleRegistry.registerModules([AllCommunityModule]);

const Depreciation: React.FC = () => {
    const location = useLocation();
    const loggedinuser: any = useUserSelector();
    const depreciationAPI: any = useDepreciationApi();
    const sageApi: any = useSagesApi();
    const facilityApi: any = useFacilitiesApi();

    const [currentPage, setCurrentPage] = useState<number>(1);
    const [searchParam, setSearchParam] = useState<string>('');
    const [totalRecords, setTotalRecords] = useState<number>(0);
    const [rowData, setrowData] = useState<any>(null);
    const [gridApi, setGridApi] = useState<any>(null);
    const [gridColumnApi, setGridColumnApi] = useState<any>(null);
    const [loadingRowId, setLoadingRowId] = React.useState<string | null>(null);
    const [isPostingAll, setIsPostingAll] = React.useState<boolean>(false);
    const [postAllStatus, setPostAllStatus] = useState<any>(null);
    const [isPopupDismissed, setIsPopupDismissed] = useState<boolean>(false);

    // Filter state management
    const filtersRef: any = React.useRef();
    const [filters, setFilters] = useState<any>({});
    const [filtersApplied, setFiltersApplied] = useState<any>({ generalFilter: false, locationFilter: false });
    const [filtersInitialized, setFiltersInitialized] = useState<boolean>(false);
    const [accmDeprAccountList, setAccmDeprAccountList] = useState<any>([]);
    const [facilityoption, setFacilityoption] = useState<any>([]);

    // Financial year calculation
    const currentDate = new Date();
    const currentMonth = currentDate.getMonth() + 1;
    const startYear = currentMonth >= 4 ? currentDate.getFullYear() : currentDate.getFullYear() - 1;
    const endYear = startYear + 1;

    const monthYearOptions = useMemo(() => {
        const startDate = new Date(2025, 11, 1); // December 2025 (month is 0-indexed)
        const endDate = new Date(endYear, 2, 1);  // March of endYear



        const options = [];
        const current = new Date(startDate);



        while (current <= endDate) {
            const month = current.toLocaleString("default", { month: "long" });
            const year = current.getFullYear();
            options.push({
                label: `${month} ${year}`,
                value: `${month}-${year}`
            });
            current.setMonth(current.getMonth() + 1);
        }



        return options;
    }, [endYear]);

    /* // Generate month-year list for dropdown
    const monthYearOptions = useMemo(() => {
        const months = [
            "April", "May", "June", "July", "August", "September",
            "October", "November", "December", "January", "February", "March"
        ];
        return months.map((month, index) => {
            const year = index < 9 ? startYear : endYear;
            return {
                label: `${month} ${year}`,
                value: `${month}-${year}`
            };
        });
    }, [startYear, endYear]); */

    // Set default to current month in financial year format
    const defaultMonthYear = useMemo(() => {
        const now = moment();
        const month = now.format("MMMM"); // e.g. August
        const year = now.month() >= 3 ? now.year() : now.year() - 1;
        return `${month}-${year}`;
    }, []);

    // Initialize selectedMonthYear from localStorage or default
    const [selectedMonthYear, setSelectedMonthYear] = useState<string>(() => {
        const savedMonthYear = localStorage.getItem('depreciationSelectedMonthYear');
        return savedMonthYear || defaultMonthYear;
    });
    const [showAll, setShowAll] = useState<boolean>(true);
    const [showPosted, setShowPosted] = useState<boolean>(false);

    // Load filters from localStorage on component mount
    useEffect(() => {
        const savedFilters = localStorage.getItem('depreciationFilters');
        if (savedFilters) {
            try {
                const parsedFilters = JSON.parse(savedFilters);
                setFilters(parsedFilters);
            } catch (error) {
                console.error('Error parsing saved filters:', error);
                setFilters({});
            }
        } else {
            setFilters({});
        }
        setFiltersInitialized(true);
    }, []);

    // Save filters to localStorage when filters change
    useEffect(() => {
        if (Object.keys(filters).length > 0) {
            localStorage.setItem('depreciationFilters', JSON.stringify(filters));
        } else {
            localStorage.removeItem('depreciationFilters');
        }
    }, [filters]);

    // Save selected month year to localStorage when it changes
    useEffect(() => {
        localStorage.setItem('depreciationSelectedMonthYear', selectedMonthYear);
    }, [selectedMonthYear]);

    // Filter configuration - make it reactive to accmDeprAccountList changes
    const filterConfig: filterConfigType[] = useMemo(() => {
        console.log("filterConfig updated with accmDeprAccountList:", accmDeprAccountList);
        return [
            {
                name: 'Accumulated Depreciation Account',
                type: 'dropdown',
                key: 'accmDeprAccountID',
                options: accmDeprAccountList,
                isMulti: false
            }
        ];
    }, [accmDeprAccountList]);

    // Get facility list
    const getfacilitylist = () => {
        const payload = {};
        facilityApi.getFacilityList(
            payload,
            (resp: any) => {
                let facilitylist: any = [];
                resp.facilityList.map((facility: any) => {
                    facilitylist.push({
                        label: facility.facilityName,
                        value: facility.facilityID,
                        data: facility
                    });
                });
                setFacilityoption(facilitylist);
            },
            (error: any) => {
                console.log("error =>", error);
                toast.error(error);
            }
        );
    };

    // Get accumulated depreciation account list
    const getAccmDeprAccountList = () => {
        sageApi.getUsedAccmDeprAccountList(
            {
                pageSize: 0,
                pageNumber: 0,
            }, // Remove pagination for dropdown - we want all accounts
            (resp: any) => {
                console.log("getUsedAccmDeprAccountList response:", resp);
                let accountList: any = [];
                if (resp && resp.sageAccountList && resp.sageAccountList.length > 0) {
                    resp.sageAccountList.forEach((sageAccountList: any) => {
                        accountList.push({
                            label: `${sageAccountList.accountNo}--${sageAccountList.accountTitle}`,
                            value: sageAccountList.accountID,
                            data: sageAccountList.accountTitle
                        });
                    });
                }
                console.log("accountList created:", accountList);
                setAccmDeprAccountList(accountList);
            },
            (error: any) => {
                console.log("error =>", error);
                toast.error(error);
            }
        );
    };

    // Get post all status
    const getPostAllStatus = (callback?: () => void) => {
        const payload: any = {};

        /* if (selectedMonthYear) {
            const [monthName, year] = selectedMonthYear.split("-");
            const monthNumber = moment().month(monthName).format("MM");
            payload.month = `${monthNumber}`;
            payload.year = `${year}`;
        } */

        sageApi.getPostAllStatus(
            payload,
            (resp: any) => {
                console.log("getPostAllStatus response:", resp);
                setPostAllStatus(resp);
                //resp.isRunning = true;
                // If callback is provided and isRunning is false, execute the callback
                if (callback && !resp?.isRunning) {
                    callback();
                }
                // If isRunning is true, the popup will show automatically via state change
            },
            (error: any) => {
                console.log("getPostAllStatus error =>", error);
                toast.error(error);
                setPostAllStatus(null);

                // If there's an error, consider it as safe to proceed (isRunning = false)
                if (callback) {
                    callback();
                }
            }
        );
    };

    const onBulkExportCsv = async () => {
        const payload: any = {
            searchParam: searchParam,
            pageSize: null,
            pageNumber: null,
        };
        if (showPosted) {
            payload.isPushToSage = 1; // Only show posted records
        }

        if (selectedMonthYear) {
            const [monthName, year] = selectedMonthYear.split("-");
            const monthNumber = moment().month(monthName).format("MM");
            payload.SearchDate = `${monthNumber}-${year}`;
        }

        // Apply filters - same as list API
        if (filters) {
            Object.keys(filters).forEach((key: any) => {
                if (filters[key]) {
                    payload[key] = filters[key];
                }
            });
        }

        /* depreciationAPI.AllAssetDepreciationExportToXLS(
            payload,
            (resp: any) => { downloadExcel(resp, 'AllAssetDepreciationXls') },
            (error: any) => {
                console.log("error =>", error);
                toast.error(error);
            }
        ); */
        /* depreciationAPI.AllAssetDepreciationExportToXLS(
            payload,
            (resp: any) => {
                //downloadPDF(resp, 'ReceiptStock');
                window.open(resp.fileUrl, '_blank', 'AllAssetDepreciationXls');
            },
            (error: any) => {
                console.log("error =>", error);
                toast.error(error);
            }
        ); */

        depreciationAPI.AllAssetDepreciationExportToXLS(
            payload,
            (resp: any) => {
                downloadExcel(resp, 'depreciation_list');
                toast.success('Depreciation report exported successfully!');
                //setIsExporting(false);
            },
            (error: any) => {
                console.log("error =>", error);
                toast.error(error || 'Failed to export depreciation report');
                //setIsExporting(false);
            }
        );

    };

    const columnDefs = [
        //{ headerCheckboxSelection: true, checkboxSelection: true, width: 50, headerClass: 'bg-[#f0f0f0]' },
        {
            headerName: 'Action',
            field: 'sageDocument',
            headerClass: 'bg-[#f0f0f0]',
            pinned: "left", minWidth: 150, width: 80,
            cellRenderer: (params: any) => {
                const { sageDocNo, gaapDepreciationLogID, deprciationDate, isDisposed, isPushToSage } = params.data;

                const depreciationYear = deprciationDate ? moment(deprciationDate).year() : null;
                const currentYear = moment().year();

                const hasPostPermission = getPermissionInfo(location.pathname, "Post To Sage", loggedinuser);

                let isDisabled = false;
                
                if (isPushToSage === 1) {
                    // If already posted to Sage, always disable
                    isDisabled = true;
                } else if (isPushToSage === 0) {
                    // If not posted, check other conditions
                    isDisabled =
                        !hasPostPermission ||
                        loadingRowId === gaapDepreciationLogID ||
                        depreciationYear !== currentYear ||
                        isDisposed;
                }

                return (
                    <div className="flex items-center justify-between">
                        <Button
                            onClick={() => postToSage(params.data)}
                            disabled={isDisabled}
                        >
                            {sageDocNo
                                ? "Posted"
                                : loadingRowId === gaapDepreciationLogID
                                    ? "Posting..."
                                    : "Post To Sage"}
                        </Button>

                    </div>
                );
            },
        },
        {
            headerName: 'Asset ID',
            field: 'assetCode',
            headerClass: 'bg-[#f0f0f0]',
            pinned: "left", minWidth: 190, width: 100,
            cellRenderer: (data: any) => {
                return (
                    <p className='hover:text-primary font-semibold cursor-pointer' title={data.value}>{data.value}</p>
                )
            },
            onCellClicked: (param: any) => {
                const url = URLS.ASSETS_DETAILS(param.data.assetID);
                window.open(url, '_blank');
            }
        },
        {
            headerName: 'Asset Name',
            field: 'assetName',
            headerClass: 'bg-[#f0f0f0]',
            pinned: "left", minWidth: 300, flex: 1,
            cellRenderer: (data: any) => {
                return (
                    <p className='hover:text-primary font-semibold cursor-pointer' title={data.value}>{data.value}</p>
                )
            },
            onCellClicked: (param: any) => {
                const url = URLS.ASSETS_DETAILS(param.data.assetID);
                window.open(url, '_blank');
            }
        },
        {
            headerName: 'Depreciation Date',
            field: 'deprciationDate',
            headerClass: 'bg-[#f0f0f0]',
            minWidth: 170,
            flex: 1,
            cellRenderer: (data: any) =>
                data.value ? moment(data.value).format(DATE_FORMAT) : '--',
        },
        {
            headerName: 'Cost Basis',
            field: 'costBasis',
            headerClass: 'bg-[#f0f0f0] ag-right-aligned-header',
            minWidth: 170,
            flex: 1,
            cellClass: 'ag-right-aligned-cell',
            cellRenderer: (data: any) =>
                <Currency currency="USD" value={data.value}></Currency>
        },
        {
            headerName: 'Opening Balance',
            field: 'purchaseCost',
            headerClass: 'bg-[#f0f0f0] ag-right-aligned-header',
            minWidth: 170,
            flex: 1,
            cellClass: 'ag-right-aligned-cell',
            cellRenderer: (data: any) =>
                <Currency currency="USD" value={data.value}></Currency>
        },
        { headerName: 'Current Month Depreciation', field: 'depriciationAmount', headerClass: 'bg-[#f0f0f0] ag-right-aligned-header', width: 240, cellClass: 'ag-right-aligned-cell', cellRenderer: (data: any) => <Currency currency="USD" value={data.value} /> },
        {
            headerName: 'Accm Depr',
            field: 'accmDepr',
            headerClass: 'bg-[#f0f0f0] ag-right-aligned-header',
            minWidth: 170,
            flex: 1,
            cellClass: 'ag-right-aligned-cell',
            cellRenderer: (data: any) =>
                <Currency currency="USD" value={data.value}></Currency>
        },
        /* {
            headerName: 'YTD Depr',
            field: 'depriciationAmount',
            headerClass: 'bg-[#f0f0f0] ag-right-aligned-header',
            minWidth: 170,
            flex: 1,
            cellClass: 'ag-right-aligned-cell',
            cellRenderer: (data: any) =>
                <Currency currency="USD" value={data.value}></Currency>
        }, */
        {
            headerName: 'Book Value',
            field: 'bookValueEnd',
            headerClass: 'bg-[#f0f0f0] ag-right-aligned-header',
            minWidth: 170,
            flex: 1,
            cellClass: 'ag-right-aligned-cell',
            cellRenderer: (data: any) =>
                <Currency currency="USD" value={data.value}></Currency>
        },
        /* {
            headerName: 'Closing Balance',
            field: 'bookValueEnd',
            headerClass: 'bg-[#f0f0f0] ag-right-aligned-header',
            minWidth: 170,
            flex: 1,
            cellClass: 'ag-right-aligned-cell',
            cellRenderer: (data: any) =>
                <Currency currency="USD" value={data.value}></Currency>
        }, */
        {
            headerName: 'Sage Doc No',
            field: 'sageDocNo',
            headerClass: 'bg-[#f0f0f0]',
            minWidth: 150,
            flex: 1,
            cellRenderer: (data: any) => data.value || '--',
        },
        {
            headerName: 'Sage Posting Date',
            field: 'sagePostingDate',
            headerClass: 'bg-[#f0f0f0]',
            minWidth: 150,
            flex: 1,
            cellRenderer: (data: any) =>
                data.value ? moment(data.value).format(DATE_FORMAT) : '--',
        }
    ];

    const onPostAll = () => {
        // Check permission before performing post all action
        if (!getPermissionInfo(location.pathname, "Post All", loggedinuser)) {
            toast.error(`You don't have Post All permission`);
            return;
        }

        // Reset popup dismissed state for new operation
        setIsPopupDismissed(false);

        // First check if any post all process is already running
        getPostAllStatus(() => {
            // This callback will only execute if isRunning is false
            setIsPostingAll(true);

            const payload: any = {
                month: '',
                year: '',
                pageSize: PAGE_SIZE,
                pageNumber: currentPage,
            };
            if (selectedMonthYear) {
                const [monthName, year] = selectedMonthYear.split("-");
                const monthNumber = moment().month(monthName).format("MM");
                payload.month = `${monthNumber}`;
                payload.year = `${year}`;
            }

            // Apply filters - same as list API
            if (filters) {
                Object.keys(filters).forEach((key: any) => {
                    if (filters[key]) {
                        payload[key] = filters[key];
                    }
                });
            }

            sageApi.postAll(
                payload,
                (resp: any) => {
                    console.log("response =>", resp);
                    setIsPostingAll(false);
                    getDepreciations();
                    getPostAllStatus();
                    if (resp.jobId) {
                        toast.success(resp?.message);
                    } else {
                        getDepreciations();
                        toast.error(resp.message || "Connection Failed");
                    }
                },
                (error: any) => {
                    setIsPostingAll(false);
                    getDepreciations();
                    console.log("error =>", error);
                    toast.error(error);
                }
            );
        });
    };

    const postToSage = (row: any) => {
        // Check permission before performing post action
        if (!getPermissionInfo(location.pathname, "Post To Sage", loggedinuser)) {
            toast.error(`You don't have Post To Sage permission`);
            return;
        }

        // Reset popup dismissed state for new operation
        setIsPopupDismissed(false);

        // First check if any post all process is already running
        getPostAllStatus(() => {
            // This callback will only execute if isRunning is false
            setLoadingRowId(row.gaapDepreciationLogID);

            const payload = {
                assetID: row.assetID,
                logID: row.gaapDepreciationLogID,
            };
            sageApi.PostAssetDepreciationToSage(
                payload,
                (resp: any) => {
                    console.log("response =>", resp);
                    setLoadingRowId(null);
                    getDepreciations();
                    if (resp.successful) {
                        toast.success(resp?.message);
                    } else {
                        setLoadingRowId(null);
                        toast.error(resp.message || "Connection Failed");
                    }
                },
                (error: any) => {
                    console.log("error =>", error);
                    setLoadingRowId(null);
                    toast.error(error);
                }
            );
        });
    };


    const getDepreciations = () => {
        const payload: any = {
            pageSize: PAGE_SIZE,
            pageNumber: currentPage,
            searchParam: searchParam,
        };

        if (showPosted) {
            payload.isPushToSage = 1; // Only show posted records
        }
        // Apply month-year filter in MM-YYYY format
        if (selectedMonthYear) {
            const [monthName, year] = selectedMonthYear.split("-");
            const monthNumber = moment().month(monthName).format("MM");
            payload.SearchDate = `${monthNumber}-${year}`;
        }


        // Apply filters
        if (filters) {
            Object.keys(filters).forEach((key: any) => {
                if (filters[key]) {
                    payload[key] = filters[key];
                }
            });
        }

        depreciationAPI.GetAssetDepreciationList(
            payload,
            (resp: any) => {
                setrowData(resp.depreciationList);
                setTotalRecords(resp.totalRecord);
            },
            (error: any) => {
                toast.error(error);
            }
        );
    };

    const onGridReady = (params: any) => {
        setGridApi(params.api);
        setGridColumnApi(params.columnApi);
    };

    const onRowClicked = (event: any) => {
        if (!event.event.target.closest('input[type="checkbox"]')) {
            event.node.setSelected(false); // Unselect row if it's clicked, not by checkbox
        }
    };

    useEffect(() => {
        if (filtersInitialized) {
            getDepreciations();
        }
    }, [currentPage, searchParam, selectedMonthYear, showAll, showPosted, filters, filtersInitialized]);

    // Load account list and facility list
    useEffect(() => {
        getAccmDeprAccountList();
        getfacilitylist();
    }, []);

    // Update filters applied state
    useEffect(() => {
        const hasActiveFilters = filterConfig.some((filter) => filters[filter.key]);
        const hasActiveLocationFilter = filters?.hasOwnProperty("facilityID");
        setFiltersApplied({
            generalFilter: hasActiveFilters,
            locationFilter: hasActiveLocationFilter,
        });
    }, [filters, filterConfig]);

    return (
        <Layout>
            {/* Full Page Loader for Post All */}
            {isPostingAll && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                    <div className="bg-white p-6 rounded-lg shadow-lg flex flex-col items-center">
                        <Loader />
                        <p className="mt-4 text-lg font-semibold">Posting All to Sage...</p>
                        <p className="text-sm text-gray-600">Please wait, this may take a few moments</p>
                    </div>
                </div>
            )}

            {/* Full Page Loader for Post All Status Running */}
            {postAllStatus?.isRunning && !isPopupDismissed && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                    <div className="bg-white p-6 rounded-lg shadow-lg flex flex-col items-center relative">
                        {/* Close Button */}
                        <button
                            onClick={() => setIsPopupDismissed(true)}
                            className="absolute top-3 right-3 text-gray-500 hover:text-gray-700 text-xl font-bold w-6 h-6 flex items-center justify-center"
                            aria-label="Close"
                            title="Close"
                        >
                            ×
                        </button>

                        <Loader />
                        <p className="mt-4 text-lg font-semibold">Bulk Depreciation Posting is in Progress</p>
                        {/* {postAllStatus?.jobInfo && (
                            <p className="text-sm font-medium text-blue-600 mb-2">
                                Progress: {postAllStatus.jobInfo.processed || 0} / {postAllStatus.jobInfo.totalCount || 0}
                            </p>
                        )} */}
                        <p className="text-sm text-gray-600">You can continue working by closing this message. You will receive an email after the process is completed.</p>
                    </div>
                </div>
            )}

            <Header title='Depreciation List'>
                <Header.Right>
                    <div className="flex items-center gap-3">
                        <Button
                            theme='primary'
                            onClick={onPostAll}
                            disabled={!getPermissionInfo(location.pathname, "Post All", loggedinuser) || isPostingAll || showPosted || !rowData || rowData.length === 0}
                        >
                            {isPostingAll ? "Posting All..." : "Post All"}
                        </Button>
                        <Dropdown>
                            <Dropdown.Button>
                                <Button
                                    theme='secondary'
                                    disabled={!rowData || rowData.length === 0}
                                >
                                    Bulk Actions
                                </Button>
                            </Dropdown.Button>
                            <Dropdown.Content title='Create New Facility' className='!w-[39.563rem]'>
                                <Menu disabled={!getPermissionInfo(location.pathname, "Export", loggedinuser) || !rowData || rowData.length === 0} onClick={onBulkExportCsv}>Export excel / csv </Menu>
                                {/* <Menu disabled={!getPermissionInfo(location.pathname, "Export", loggedinuser)} onClick={onBulkExportPdf}>Export pdf</Menu> */}
                            </Dropdown.Content>
                        </Dropdown>
                    </div>
                </Header.Right>
            </Header>

            {/* Pagination + Search */}
            <div className='flex items-center justify-between pl-5 pr-3 border-b border-gray-200 h-[3.75rem]'>
                <Pagination
                    perPage={PAGE_SIZE}
                    totalRecords={totalRecords}
                    onPageChange={setCurrentPage}
                    currentPage={currentPage}
                />
                {/* <Search onSearch={setSearchParam} placeholder='Search by name or serial number' /> */}
            </div>

            {/* Month-Year Filter */}
            <div className='bg-[#FAFAFA] w-full'>
                <div className='flex justify-between px-5 py-2 items-center'>
                    {/* Left side - Month Year Filter and Filters */}
                    <div className='flex gap-4 items-center'>
                        <select
                            className="border border-gray-300 rounded-md px-3 py-1 text-sm"
                            value={selectedMonthYear}
                            onChange={(e) => setSelectedMonthYear(e.target.value)}
                        >
                            {monthYearOptions.map((option) => (
                                <option key={option.value} value={option.value}>
                                    {option.label}
                                </option>
                            ))}
                        </select>

                        {/* Filter Button */}
                        <Button theme='light' onClick={() => filtersRef.current.showModal()}>
                            Filter <Icon name='filter' size={1.40} className={filtersApplied.generalFilter ? "text-blue-700" : ""} />
                        </Button>

                        {/* Location Filter */}
                        <Dropdown>
                            <Dropdown.Button>
                                <Button theme='light'><Icon name='grlocation' size={1.20} className={filtersApplied.locationFilter ? "text-blue-700" : ""} /> Location <Icon name='arrowdown' size={1.10} /></Button>
                            </Dropdown.Button>
                            <Dropdown.Content >
                                {facilityoption?.map((facility: any, index: number) => {
                                    return (
                                        <Menu key={index} onClick={() => {
                                            console.log('facility', facility);
                                            setFilters({ ...filters, facilityID: facility.value })
                                        }}>{facility.label}</Menu>
                                    )
                                }
                                )}
                            </Dropdown.Content>
                        </Dropdown>

                        {/* Clear Filters Button */}
                        <p className='text-primary font-semibold text-sm cursor-pointer' onClick={() => {
                            setFilters({});
                            setSelectedMonthYear(defaultMonthYear);
                            localStorage.removeItem('depreciationFilters');
                            localStorage.removeItem('depreciationSelectedMonthYear');
                        }} >Clear Filters</p>
                    </div>

                    {/* Right side - Toggle buttons */}
                    <div className='border border-primary rounded-md overflow-hidden flex'>
                        <Button
                            theme={showAll ? 'blue' : 'light'}
                            className={`!rounded-none !border-0 !border-r ${showAll ? 'border-primary' : 'border-gray-300'} px-3`}
                            onClick={() => {
                                setShowAll(true);
                                setShowPosted(false);
                                setCurrentPage(1); // reset page to 1 when filter changes
                            }}
                        >
                            All
                        </Button>

                        <Button
                            theme={showPosted ? 'blue' : 'light'}
                            className='!rounded-none !border-0 px-3'
                            onClick={() => {
                                setShowPosted(true);
                                setShowAll(false);
                                setCurrentPage(1);
                            }}
                        >
                            Posted
                        </Button>
                    </div>
                </div>


            </div>

            {/* Grid */}
            <div className='bg-[#FAFAFA] w-full'>
                <div className="ag-theme-alpine px-4 w-full h-1/2">
                    <AgGridReact
                        columnDefs={columnDefs as any}
                        rowData={rowData || []}
                        rowSelection="multiple"
                        onGridReady={onGridReady}
                        pagination={false}
                        domLayout="autoHeight"
                        onRowClicked={onRowClicked}
                        loadingOverlayComponent={Loader}
                        noRowsOverlayComponent={() => (
                            <div className="flex items-center justify-center h-full">
                                <div className="text-center text-gray-500">
                                    <div className="text-lg font-medium">No Data Found</div>
                                </div>
                            </div>
                        )}
                    />
                </div>
            </div>

            {/* Filters Modal */}
            <Filters _ref={filtersRef} config={filterConfig} filters={filters} onUpdate={setFilters} />
        </Layout>
    );
};

export default Depreciation;